var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.97 18.383L14.614 15.027C13.1661 15.6862 11.5908 16.0184 10 16C8.35988 16.0204 6.73671 15.6664 5.254 14.965C4.10468 14.4042 3.07264 13.6298 2.213 12.683C1.30049 11.7049 0.583297 10.5613 0.1 9.314L0 9L0.105 8.684C0.82781 6.84029 2.04426 5.23116 3.621 4.033L1 1.412L2.413 0L19.382 16.969L17.972 18.383H17.97ZM5.036 5.449C3.75792 6.34491 2.74865 7.57271 2.117 9C3.47142 12.1249 6.59587 14.1067 10 14C11.0498 14.0086 12.0936 13.8396 13.087 13.5L11.287 11.7C10.8863 11.8964 10.4462 11.999 10 12C8.34746 11.9896 7.01037 10.6525 7 9C7.00048 8.55277 7.10309 8.11155 7.3 7.71L5.036 5.449ZM17.852 12.61L16.46 11.219C17.0456 10.5569 17.5256 9.80844 17.883 9C16.5304 5.87358 13.4047 3.89108 10 4C9.753 4 9.505 4.009 9.265 4.026L7.5 2.259C8.32163 2.08323 9.15979 1.9964 10 2C11.6401 1.97965 13.2633 2.33362 14.746 3.035C15.8953 3.59573 16.9274 4.37019 17.787 5.317C18.6991 6.29396 19.4163 7.43607 19.9 8.682L20 9L19.895 9.316C19.4268 10.5341 18.7342 11.6535 17.853 12.616L17.852 12.61Z",
    fill: "#020334",
    fillOpacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCross);
export default __webpack_public_path__ + "static/media/eye-cross.d0c95fa511550c589c242380a4912091.svg";
export { ForwardRef as ReactComponent };